import { Link } from "react-router-dom";
import { dl } from "@/lib/docstate";
import { Instagram, Mail, Phone } from "lucide-react";
import { useDocstate } from "@/context/DocstateContext";

export const DocstateFooter = () => {
  const data = useDocstate();
  const s = data?.settings || {};
  const light = (s.theme || "dark") === "light";
  const logo = light ? (s.logo_url || s.logo_dark_url) : (s.logo_dark_url || s.logo_url);
  const wa = (s.whatsapp || "").replace(/[^\d]/g, "");

  return (
    <footer className="border-t border-[#C9A24B]/15 bg-[#0B0B0C]" data-testid="docstate-footer">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-8 lg:px-12">
        <div className="grid gap-10 md:grid-cols-5">
          <div className="md:col-span-2">
            {logo ? <img src={logo} alt="Docstate Properties" className="h-11 w-auto object-contain" /> : <span className="ds-display text-2xl text-white">DOCSTATE</span>}
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-[#8A7A6F]">
              {s.tagline || "Doctor of Real Estate — curated residences and investments across Dubai's most sought-after communities."}
            </p>
            <div className="mt-5 flex gap-3">
              {s.instagram && (
                <a href={s.instagram} target="_blank" rel="noreferrer" aria-label="Instagram" className="flex h-10 w-10 items-center justify-center rounded-full border border-[#C9A24B]/30 text-[#C9A24B] transition-colors hover:bg-[#C9A24B]/10">
                  <Instagram className="h-4 w-4" />
                </a>
              )}
            </div>
          </div>
          <div>
            <p className="ds-eyebrow">Properties</p>
            <ul className="mt-4 space-y-2.5 text-sm text-[#C9BBB2]">
              <li><Link to={dl("/buy")} className="hover:text-[#F3E5AB]">Buy</Link></li>
              <li><Link to={dl("/rent")} className="hover:text-[#F3E5AB]">Rent</Link></li>
              <li><Link to={dl("/commercial")} className="hover:text-[#F3E5AB]">Commercial</Link></li>
              <li><Link to={dl("/holiday-homes")} className="hover:text-[#F3E5AB]">Holiday Homes</Link></li>
            </ul>
          </div>
          <div>
            <p className="ds-eyebrow">Company</p>
            <ul className="mt-4 space-y-2.5 text-sm text-[#C9BBB2]">
              <li><Link to={dl("/about")} className="hover:text-[#F3E5AB]">About Us</Link></li>
              <li><Link to={dl("/team")} className="hover:text-[#F3E5AB]">Meet the Team</Link></li>
              <li><Link to={dl("/sell")} className="hover:text-[#F3E5AB]">Sell</Link></li>
              <li><Link to={dl("/property-management")} className="hover:text-[#F3E5AB]">Property Management</Link></li>
              <li><Link to={dl("/careers")} className="hover:text-[#F3E5AB]">Careers</Link></li>
            </ul>
          </div>
          <div>
            <p className="ds-eyebrow">Insights & Contact</p>
            <ul className="mt-4 space-y-2.5 text-sm text-[#C9BBB2]">
              <li><Link to={dl("/blog")} className="hover:text-[#F3E5AB]">Blog</Link></li>
              <li><Link to={dl("/area-guides")} className="hover:text-[#F3E5AB]">Area Guides</Link></li>
              <li><Link to={dl("/contact")} className="hover:text-[#F3E5AB]">Contact</Link></li>
            </ul>
            <ul className="mt-4 space-y-3 text-sm text-[#C9BBB2]">
              {s.phone && <li className="flex items-center gap-2"><Phone className="h-4 w-4 text-[#C9A24B]" /><a href={`tel:${s.phone}`} className="hover:text-[#F3E5AB]">{s.phone}</a></li>}
              {s.email && <li className="flex items-center gap-2"><Mail className="h-4 w-4 text-[#C9A24B]" /><a href={`mailto:${s.email}`} className="hover:text-[#F3E5AB]">{s.email}</a></li>}
            </ul>
            {wa && <a href={`https://wa.me/${wa}`} target="_blank" rel="noreferrer" className="ds-outline-btn mt-5 px-4 py-2.5 text-xs">WhatsApp Us</a>}
          </div>
        </div>
        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-white/5 pt-6 text-xs text-[#6E635B] sm:flex-row">
          <p>© {new Date().getFullYear()} Docstate Properties. All rights reserved.</p>
          <p>Dubai, United Arab Emirates</p>
        </div>
      </div>
    </footer>
  );
};
